import androidx.compose.foundation.layout.Row
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import com.essntl.features.itinerary.ui.edit_itinerary.components.messaging.MessageType
import com.essntl.features.itinerary.ui.edit_itinerary.components.messaging.MessageTypeCheckBox

@Composable
fun CheckBoxRow(
    messageType: MessageType,
    enabled: Boolean,
    checked: Boolean,
    onCheckedChange: (Boolean) -> Unit,
    ) {
    Row(
        verticalAlignment = Alignment.CenterVertically,
    ) {
        MessageTypeCheckBox(
            messageType,
            enabled = enabled,
            checked = checked,
            onCheckedChange = onCheckedChange,
        )
    }
}